import dayjs from 'dayjs';
import React from 'react';
import { CustomDatePicker, DatePickerMode } from '../../../components/UI/CustomDatePicker/CustomDatePicker';

export type DeadlineEditableFieldProps = {
  startDate: Date | null;
  targetDate: Date | null;
  onChange: (date: Date | null) => void;
  editingDisabled?: boolean;
  hideOutline?: boolean;
  emptyLabel?: string;
  placeholder?: string;
  mode: DatePickerMode;
};

export const DeadlineEditableField = ({
  startDate,
  targetDate,
  onChange,
  editingDisabled = false,
  hideOutline = false,
  emptyLabel = 'No date',
  placeholder = 'Set date',
  mode,
}: DeadlineEditableFieldProps) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const initialValue = mode === 'startDate' ? startDate : targetDate;

  return !editingDisabled && isEditing ? (
    <CustomDatePicker
      onChange={(date) => onChange(date?.toDate() || null)}
      onClose={() => setIsEditing(false)}
      startDate={startDate}
      targetDate={targetDate}
      mode={mode}
      hideOutline={hideOutline}
      placeholder={placeholder}
    />
  ) : (
    <div className="cursor-pointer" onClick={() => setIsEditing(true)}>
      {initialValue ? (
        <span className="font-normal">{dayjs(initialValue).format('MMM DD, YYYY')}</span>
      ) : (
        <span className="font-normal text-neutral-700">{emptyLabel}</span>
      )}
    </div>
  );
};
